import {
  normalizeBlockDocId,
  resolveClientBlockDocPath,
} from "../../../invitations/clientBlockPathResolver";

export const toTrimmedLabel = (value) =>
  typeof value === "string" ? value.trim() : "";

export const resolveFolderRenameTargetLabel = (
  draftLabel,
  originalPersistedLabel,
) => {
  const trimmedDraft = toTrimmedLabel(draftLabel);
  if (trimmedDraft !== "") return trimmedDraft;
  return toTrimmedLabel(originalPersistedLabel);
};

export const isFolderRenameUnchanged = (draftLabel, originalDisplayLabel) =>
  toTrimmedLabel(draftLabel) === toTrimmedLabel(originalDisplayLabel);

export const getLowercaseBlockDocId = (blockId) =>
  normalizeBlockDocId(blockId);

export const buildFolderRenameWritePlan = ({
  client,
  blocks,
  targetLabel,
}) => {
  if (!client || !Array.isArray(blocks)) return [];

  const safeLabel = toTrimmedLabel(targetLabel);

  return blocks
    .map((block) => {
      const blockDocPath = resolveClientBlockDocPath(client, block?.id);
      if (!blockDocPath) return null;

      return {
        blockDocPathSegments: blockDocPath.pathSegments,
        label: safeLabel,
      };
    })
    .filter(Boolean);
};
